export const iconFontAwesomeEmojiFaceGrinTongueWink = (
	<i className="fa-solid fa-face-grin-tongue-wink"></i>
);
